.vs-error {
  color: #d50000;
  color:  var(--text-error);
}

.vs-checkbox-section {
  display: flex;
  flex-flow: row;
}

.vs-checkbox {
  opacity: 1 !important;
}
.vs-form {
  input {
    &.vs-checkbox {
      &.has-error {
        border: 3px solid #d50000;
        border: 3px solid var(--text-error);
        border-radius: 3px;
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
      }
    }

    &.vs-input-radio {
      &.has-error:after {
        border: 3px solid #d50000;
        border: 3px solid var(--text-error);
        border-radius: 50px;
      }
    }

    &.vs-date-padding {
      padding: 27px 45px 10px 15px;
    }
  }

  .vs-label {
    &.vs-label-eyebrow {
      &.vs-date-label {
        &.vs-has-focus {
          top: 35px;
          left: 12px;
        }
      }
    }
  }

  fieldset {
    margin-left: 0;
    padding-left: 0;
    border: 0;
  }

  .required {
    color: #a94442;
    color: var(--text-required);
    font-size: 12px;
    padding: 0;
  }

  .vs-input-radio {
    opacity: 1 !important;
  }

}

.vs-height-auto {
  height: auto !important;
}

.vs-loading-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  opacity: .9;
  z-index: 2;
  text-align: center;
  padding-top: 20%
}

.visa-icon.vs-font-size-standard {
  font-size: 18px;
}

.vs-legend-container {
  display: flex;
  align-items: center;
}
